export const getDescendantProp = (s: string, r: any) => {
    try {
        return s.split('.').reduce((a, b) => a[b], r);
    } catch (e) {
        return null;
    }
};
